/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import PropTypes from 'prop-types';
import { NEW_ORGANISATION_TRANSFER_QUERY } from '../../services/apps/AccountService';

import NewCommercialAgreementForm from './NewCommercialAgreementForm';
import { Loading } from '../../components/Loading';
import { withAccount } from '../../components/AccountContext';

export const UPLOAD_COMMERCIAL_AGREEMENT_MUTATION = gql`
  mutation UploadCommercialAgreement($input: UploadCommercialAgreementInput!) {
    uploadCommercialAgreement(input: $input) {
      commercialAgreement {
        id
      }
    }
  }
`;

class NewCommercialAgreementContainer extends Component {
  render() {
    const { currentAccount } = this.props;

    const variables = {
      id: currentAccount,
    };

    return (
      <Query
        query={NEW_ORGANISATION_TRANSFER_QUERY}
        variables={variables}
        fetchPolicy="network-only"
      >
        {({ data, loading, error }) => {
          if (loading) {
            return <Loading />;
          }

          if (error) return `Error! ${error.message}`;

          const accounts = data && data.account ? data.account.canTransferToInOrganisation : [];

          return (
            <Mutation mutation={UPLOAD_COMMERCIAL_AGREEMENT_MUTATION}>
              {uploadCommercialAgreement => (
                <NewCommercialAgreementForm
                  accounts={accounts}
                  currentAccount={currentAccount}
                  uploadCommercialAgreement={uploadCommercialAgreement}
                />
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

NewCommercialAgreementContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
};

export default withAccount(NewCommercialAgreementContainer);
